/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgArrowsAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M9 2v2H5.415L12 10.585 18.584 4H15V2h7v7h-2V5.414L13.415 12 20 18.585V15h2v7h-7v-2h3.585L12 13.415 5.414 20H9v2H2v-7h2v3.584L10.585 12 4 5.415V9H2V2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgArrowsAlt as ArrowsAlt };
